import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/App";
import { translations } from "@/i18n";
import { Reveal, Eyebrow } from "@/components/Reveal";

const IMG =
  "https://images.pexels.com/photos/17157385/pexels-photo-17157385.jpeg?auto=compress&cs=tinysrgb&w=1400";

const Serve = () => {
  const { lang } = useLanguage();
  const t = translations[lang].serve;

  return (
    <section id="who-we-serve" data-testid="who-we-serve-section" className="bg-[#0A1128] py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid gap-16 lg:grid-cols-12 lg:gap-20">
          <Reveal className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -left-4 -top-4 h-full w-full border border-[#D4AF37]/40" />
              <motion.div
                whileHover={{ scale: 0.985 }}
                transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                className="relative aspect-[3/4] overflow-hidden"
              >
                <img
                  src={IMG}
                  alt="Las Vegas, Nevada"
                  className="h-full w-full object-cover grayscale-[35%] transition-[filter,transform] duration-700 hover:grayscale-0"
                />
                <div className="absolute inset-0 bg-[#0A1128]/25" />
              </motion.div>
            </div>
          </Reveal>

          <div className="lg:col-span-7">
            <Reveal>
              <Eyebrow>{t.eyebrow}</Eyebrow>
              <h2 className="font-display text-4xl font-black tracking-tighter text-white sm:text-5xl">
                {t.title}
              </h2>
            </Reveal>

            <div className="mt-14">
              {t.groups.map((g, i) => (
                <Reveal key={`${lang}-${i}`} delay={i * 0.08}>
                  <div
                    data-testid={`serve-group-${i}`}
                    className="group flex items-start justify-between gap-6 border-t border-white/10 py-10 transition-colors duration-500 last:border-b hover:bg-white/[0.02]"
                  >
                    <div>
                      <h3 className="font-display text-xl font-semibold tracking-tight text-white transition-colors duration-300 group-hover:text-[#D4AF37] md:text-2xl">
                        {g.title}
                      </h3>
                      <p className="mt-3 max-w-md text-sm font-light leading-relaxed text-slate-300 md:text-base">
                        {g.body}
                      </p>
                    </div>
                    <ArrowUpRight className="mt-1 h-6 w-6 shrink-0 text-white/20 transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-[#D4AF37]" />
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Serve;
